'use client';

import { installCsrfRetry } from '@/lib/csrf';

// At module scope, not in an effect: children's mount effects run before a
// parent's, so an effect here could come too late for a POST fired on mount.
// No request-scoped API is read, so the root layout stays static.
installCsrfRetry();

export function CsrfRetryInstaller() {
  return null;
}
